import { render, staticRenderFns } from "./CateringHoursForm.vue?vue&type=template&id=6edf938a"
import script from "./CateringHoursForm.vue?vue&type=script&lang=ts"
export * from "./CateringHoursForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports